import {PdfDetailedUserHeaderComponent} from "./pdfDetailedUserHeaderComponent";
import {Localizer} from "../../../../infrastructure/localization/localizer";
import { dateTimeStringFromApiToDate } from "index";
import PdfHeaderRow from "../components/pdfHeaderRow";
import { GetUddannelsestypeTranslation } from "core/sharedmodels/stilling/uddannelseTypeEnum";
import { getStillingDurationDisplay } from "services/api/logbogStilling/stillingInfo";
import { PdfKompetenceHeaderModel } from "../models/pdfKompetenceHeaderModel";

type PdfKompetenceHeaderComponentProps = {
    brugerId: string,
    data: PdfKompetenceHeaderModel,
    disableUserInfo?: boolean,
}

export function PdfKompetenceHeaderComponent({disableUserInfo=false, brugerId, data}: PdfKompetenceHeaderComponentProps) {
    const { brugerMaalbeskrivelse, speciale, stilling } = data;

    return (
        <div className={"card shadow-none"}>
            <div className={"card-body flex-container-column flex-space"}>
                {!disableUserInfo &&
                    <PdfDetailedUserHeaderComponent bruger={data.bruger}/>
                }
                <PdfHeaderRow>
                    <PdfHeaderRow.Entry
                        label={Localizer.global_speciale()}
                        value={speciale.navn}
                    />
                    <PdfHeaderRow.Entry
                        label={Localizer.global_uddannelsestrin()}
                        value={GetUddannelsestypeTranslation(brugerMaalbeskrivelse.uddannelseType)}
                    />
                </PdfHeaderRow>
                <PdfHeaderRow>
                    <PdfHeaderRow.Entry
                        isColumn
                        label={Localizer.global_maalbeskrivelse()}
                        value={[
                            brugerMaalbeskrivelse.navn,
                            dateTimeStringFromApiToDate(brugerMaalbeskrivelse.versionsdato).dateWithoutTimeFormat(false)
                        ]}
                    />
                    {stilling &&
                        <PdfHeaderRow.Entry
                            isColumn
                            label={Localizer.stilling()}
                            value={[
                                stilling.stillingNr,
                                stilling.uddannelsessted,
                                getStillingDurationDisplay(stilling)
                            ]}
                        />
                    }
                </PdfHeaderRow>
            </div>
        </div>
    );
}
